namespace TabAurous.Common {
    export class SliderDialogOptions {
        initDialog: () => Serenity.TemplatedDialog<any>;
        onDataChangeCallback?: () => void;
        sliderWidth?: any;
        entityOrId?: any;
        routeKey?: string;
        showNextPreviousButtons?: boolean;
        overlayClick?: () => void;
        afterShownCallback?: () => void;
    }

    @Serenity.Decorators.registerClass()
    export class SliderDialog extends Serenity.TemplatedWidget<SliderDialogOptions>  {

        private slider: JQuery;
        private overlayDiv: JQuery = $(`<div class="custom-slide-reveal-overlay ui-dialog" style="position: fixed; top: 0px; left: 0px; height: 100%; width: 100%; background-color: rgba(0, 0, 0, 0.5);"></div>`);
        public dlg: Serenity.TemplatedDialog<any>;
        grid: Serenity.DataGrid<any, any>;

        private key: string;
        private btnPreviousRecord: JQuery = $(`<div class="tool-button btn-previous-record icon-tool-button" style="display: none"><div class="button-outer"><span class="button-inner"><i class="fa fa-step-backward text-purple"></i> Previous</span></div></div>`);
        private btnNextRecord: JQuery = $(`<div class="tool-button btn-next-record icon-tool-button" style="display: none"><div class="button-outer"><span class="button-inner"><i class="fa fa-step-forward text-purple"></i> Next</span></div></div>`);

        constructor(container: JQuery, opt?: SliderDialogOptions) {
            super(container, opt);

            this.dlg = this.options.initDialog();
            this.key = this.createGuid();

            // #region pre/next toolbar
            let dlgUniqueId = this.dlg.element.attr("id");
            let dlgToolbar = this.dlg.element.find(`#${dlgUniqueId}_Toolbar`).find(`.tool-buttons`);

            let nextPreOuter = $(`<div class="buttons-inner"></div>`);

            this.btnPreviousRecord.click(e => {
                let self = this;

                (function back(loadedNewPage?: boolean) {
                    let listIds = self.grid.view.getItems().map(x => x[(self.grid as any).getIdProperty()]);

                    if (self.grid !== null && typeof self.grid !== 'undefined') {
                        if (loadedNewPage) {
                            let preId = listIds[listIds.length - 1];
                            self.options.entityOrId = preId;
                            self.loadByIdAndOpenSlider(preId);
                            (self.slider as any).slideReveal('show');
                        }
                        else {
                            let currentEntityId = (self.dlg as any).entityId;
                            if (currentEntityId !== null && typeof currentEntityId !== 'undefined') {

                                let currentIdIndex = listIds.indexOf(currentEntityId);
                                if (currentIdIndex <= 0) {
                                    self.backToPreviousPage(() => back(true), listIds[0]);
                                }
                                else {
                                    let preId = listIds[currentIdIndex - 1];
                                    self.options.entityOrId = preId;
                                    self.loadByIdAndOpenSlider(preId);
                                    (self.slider as any).slideReveal('show');
                                }
                            }
                        }
                    }
                })();
            });

            this.btnNextRecord.click(e => {
                let self = this;
                (function next(loadedNewPage?: boolean): void {
                    let listIds = self.grid.view.getItems().map(x => x[(self.grid as any).getIdProperty()]);

                    if (self.grid !== null && typeof self.grid !== 'undefined') {
                        if (loadedNewPage) {
                            let nextId = listIds[0];
                            self.options.entityOrId = nextId;
                            self.loadByIdAndOpenSlider(nextId);
                            (self.slider as any).slideReveal('show');
                        }
                        else {
                            let currentEntityId = (self.dlg as any).entityId;
                            if (currentEntityId !== null && typeof currentEntityId !== 'undefined') {
                                let listIds = self.grid.view.getItems().map(x => x[(self.grid as any).getIdProperty()]);

                                let currentIdIndex = listIds.indexOf(currentEntityId);
                                if (currentIdIndex >= listIds.length - 1) {
                                    self.goToNextPage(() => next(true), listIds[0]);
                                }
                                else {
                                    let nextId = listIds[currentIdIndex + 1];
                                    self.options.entityOrId = nextId;
                                    self.loadByIdAndOpenSlider(nextId);
                                    (self.slider as any).slideReveal('show');
                                }
                            }
                        }
                    }
                })();
            });

            nextPreOuter.append(this.btnPreviousRecord);
            nextPreOuter.append(this.btnNextRecord);

            dlgToolbar.find(".buttons-outer").append(nextPreOuter);

            // #endregion

            //container.appendTo(target);
            container.appendTo($("body"));

            if (this.options.showNextPreviousButtons) {
                this.btnPreviousRecord.show();
                this.btnNextRecord.show();
            }

            if ($(".custom-slide-reveal-overlay").length > 0) {
                this.overlayDiv.css("opacity", 0.3);
            }

            this.overlayDiv.insertBefore(this.element);

            this.overlayDiv.click(e => {
                if (this.options.overlayClick) {
                    this.options.overlayClick()
                } else {
                    this.closeSlider();
                }
            });


            let targetIndex = 0;
            try {
                targetIndex = Q.parseInteger($(".s-Dialog").css("z-Index"));
            } catch { }

            targetIndex = targetIndex.toString() == "NaN" ? 0 : targetIndex;
            targetIndex = targetIndex <= 1100 ? 1100 : targetIndex;

            this.overlayDiv.css("z-index", targetIndex + 1);
            this.element.css("z-index", targetIndex + 1);
            this.byId("sliderCloseButton").css("z-index", targetIndex + 1);

            this.element.css("position", "relative");

            this.dlg.element.addClass("flex-layout");

            let nbrExistedSlider = $(".slider-container").length;

            //let topHeight = $('header.main-header').height();
            this.slider = (this.byId("sliderContainer") as any).slideReveal({
                push: false,
                position: 'right',
                zIndex: 1100,
                overlay: false,
                autoEscape: true,
                //top: topHeight,
                width: Q.coalesce(this.options.sliderWidth, `calc(50% - ${nbrExistedSlider * 40}px)`),
                trigger: this.byId("sliderCloseButton"),
                show: (slider, trigger) => {
                    (this.dlg as any).handleResponsive();
                },
                shown: (slider, trigger) => {
                    //$(slider).css("right", "-10px");
                    $(slider).css("right", "0px");

                    this.options.afterShownCallback && this.options.afterShownCallback();
                },
                hide: (slider, trigger) => {
                    Q.Router.replaceLast('', true);
                },
                hidden: (slider, trigger) => {

                    try {
                        this.overlayDiv.remove();
                        if ($(".custom-slide-reveal-overlay").length == 0) {
                            $("body").removeClass("noscroll");
                        }
                    } catch { }

                    try {
                        this.element.remove();
                    } catch { }

                    try {
                        this.dlg.dialogClose();
                    } catch { }

                    $(`.slider-key-${this.key}`).last().remove();
                }
            });

            this.dlg.element.on("ondatachange", (x, data) => {
                //console.log(data);
                this.options.onDataChangeCallback && this.options.onDataChangeCallback();
            });

            this.dlg.element.one('dialogclose panelclose', () => {
                (this.slider as any).slideReveal('hide');
            });

            let adjustSize = () => {
                if (this.byId("sliderContainer")) {
                    this.byId("sliderContainer").height($(window).height());
                }
                if (this.dlg && this.dlg.element) {
                    this.dlg.element.css("width", "100%");
                }
            }
            $(window).on('resize', () => {
                adjustSize();
            });
            adjustSize();
        }

        public closeSlider() {
            try {
                (this.slider as any).slideReveal('hide');
            } catch { }
        }

        private backToPreviousPage(callback?: () => void, firstIdOfOldPage?: any) {
            let currentPage = parseInt($(".slick-pg-current").val());
            let prePage = currentPage - 1;

            let isFirstPage = false;
            if (prePage < 1) {
                prePage = 1;
                isFirstPage = true;
            }

            this.grid.view.seekToPage = prePage;
            this.grid.refresh();

            if (!isFirstPage) {
                let self = this;
                (function execCallback() {
                    setTimeout(function () {
                        if (self.grid.view.getItems()[0] !== firstIdOfOldPage) {
                            callback && callback();
                        }
                        else {
                            execCallback();
                        }
                    }, 500);
                })();
            }
        }

        private goToNextPage(callback?: () => void, firstIdOfOldPage?: any) {
            let currentTotalPage = parseInt($(".slick-pg-total").text());
            let currentPage = parseInt($(".slick-pg-current").val());
            let nextPage = currentPage + 1;

            let isLastPage = false;
            if (nextPage > currentTotalPage) {
                nextPage = currentTotalPage;
                isLastPage = true;
            }

            this.grid.view.seekToPage = nextPage;
            this.grid.refresh();

            if (!isLastPage) {
                let self = this;
                (function execCallback() {
                    setTimeout(function () {
                        if (self.grid.view.getItems()[0] !== firstIdOfOldPage) {
                            callback && callback();
                        }
                        else {
                            execCallback();
                        }
                    }, 500);
                })();
            }
        }

        public dialogOpen() {
            $("body").addClass("noscroll");

            this.dlg.dialogOpen();
            // @todo: implement route

            this.convertJqueryDialogToSlider();
            this.injectDialogIntoPanel();
        }

        public handleGridEditItem(grid: Serenity.DataGrid<any, any>) {
            this.grid = grid;

            $("body").addClass("noscroll");

            (this.grid as any).routeDialog((this.grid as any).getItemType(), this.dlg);

            (this.dlg as any).load(this.options.entityOrId, () => {
                this.dlg.dialogOpen(false);
                this.convertJqueryDialogToSlider();
                this.injectDialogIntoPanel(this.options.entityOrId);
            });
        }

        public handleEditorEditItem(grid: Serenity.DataGrid<any, any>, item: any) {
            this.grid = grid;

            $("body").addClass("noscroll");

            //(this.grid as any).routeDialog((this.grid as any).getItemType(), this.dlg);

            (this.dlg as any).load(item, () => {
                this.dlg.dialogOpen(false);
                this.convertJqueryDialogToSlider();
                this.injectDialogIntoPanel();
            });
        }

        public loadByIdAndOpenSlider(id: any) {
            Q.Router.dialog(this.element, this.dlg.element, () => window.location.hash + `/+/${this.options.routeKey}@` + 'edit/' + id);
            (this.dlg as any).load(id, () => {
                this.dlg.dialogOpen(false);
                this.convertJqueryDialogToSlider();
                this.injectDialogIntoPanel(id);
            });
        }

        public loadNewAndOpenSlider() {

            this.btnPreviousRecord.hide();
            this.btnNextRecord.hide();

            Q.Router.dialog(this.element, this.dlg.element, () => "new");
            (this.dlg as any).loadNewAndOpenDialog(false);
            this.convertJqueryDialogToSlider();
            this.injectDialogIntoPanel();
        }


        public openSlider() {

            this.btnPreviousRecord.hide();
            this.btnNextRecord.hide();

            this.dlg.dialogOpen(false);

            this.convertJqueryDialogToSlider();

            this.injectDialogIntoPanel();
        }

        private convertJqueryDialogToSlider() {
            if (!this.dlg.element.parent().is(this.byId("sliderBody"))) {
                let orgDlgParent = this.dlg.element.parent();
                this.dlg.element.appendTo(this.byId("sliderBody"));

                orgDlgParent.remove();

                this.dlg.element.addClass("ui-dialog");
                this.dlg.element.addClass("flex-layout");
                this.dlg.element.addClass("slider-full-height-width");
                this.dlg.element.addClass(`slider-key-${this.key}`);
            }
        }

        private injectDialogIntoPanel(id?: any) {
            var nbrRetry = 0;

            var self = this;
            (function appendDialogIntoPanel() {
                setTimeout(function () {
                    nbrRetry++;

                    //console.log(nbrRetry);

                    if (nbrRetry >= 100) {
                        return;
                    }

                    if (self.slider.find(".s-TemplatedDialog").length === 1) {

                        (self.slider as any).slideReveal('show');

                        //self.options.grid.element.removeClass('hidden').removeClass('panel-hidden');
                    }
                    else {
                        appendDialogIntoPanel();
                    }

                }, 100);
            })();

        }

        private createGuid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }

        getTemplate() {
            return `<div id="~_sliderContainer" class="slider-container ui-dialog j-Slider-Container" style="background-color:#fff; position:relative; border-left: solid 1px #c9c9c9; overflow:auto">
                        <div id="~_sliderCloseButton" style="width:25px; height: 25px; position: absolute; top: 10px; right: 12px;color: red; cursor: pointer">
                            <i class="fa fa-lg fa-times"></i>
                        </div>
                        <div id="~_sliderBody" class="j-Slider-Body">
                        </div>
                    </div>`;
        }
    }
}